import React from "react";
import "./ImagePreview.css";
import { bytesToMB } from "../../../utils";
import { filerUrl } from "../../../../../../_utils/utils";
import { useImagesBaseContext } from "../../contexts/ImageBaseContext";
import { useQuery } from "react-query";
import serverApi from "../../../../../../_api/server.api";
import { FIVE_MIN, FIVE_SECONDS } from "../../../../../../_constants/constants";

function ImagePreview() 
{
    const { selectedImageInfo } = useImagesBaseContext();
    const linkedEntitiesQuery = useQuery({
        queryKey: ["linkedEntities", selectedImageInfo._id],
        queryFn: () => serverApi.getLinkedEntities(selectedImageInfo._id),
        staleTime: FIVE_SECONDS,
    });
    const linkedEntitiesCount = linkedEntitiesQuery.data?.results?.length;

    return (
        <div className="image-preview">
            <img src={filerUrl(selectedImageInfo.filerId, 1800)} alt="image" />
            <div className="image-preview-info-bx">
                <div className="image-preview-info-name">
                    {selectedImageInfo.name}
                </div>
                <div className="image-preview-additional-info">
                    {bytesToMB(selectedImageInfo.size)} MB | {linkedEntitiesCount} Linked
                </div>
            </div>
        </div>
    );
}

export default ImagePreview;